const React = require("react");
const noop = require("mn-utils/noop");
const Ripple = require("../../../../../dumb/Ripple");

const TabBtn = ({children, activeTab, handleChange = noop(), tabName, type}) => {
  return (
    <Ripple
      className={
        `w228 h48 layoutRow jcC aiC cF.active bg3E4044.active bgFAFAFA.inactive bxsh4c0.25.inactive rlt9.left rlb9.left rrt9.right rrb9.right`
        + (activeTab === tabName ? ' active' : ' inactive')
        + (` ${type}`)
      }
      onClick={() => handleChange && handleChange(tabName)}
    >
      {children}
    </Ripple>
  )
}

module.exports = ({activeTab, handleChange}) => {
  return (
    <div className="layoutRow">
      <TabBtn
        activeTab={activeTab}
        handleChange={handleChange}
        tabName="paymentOrders"
        type="left"
      >
        Payment Orders
      </TabBtn>
      <TabBtn
        activeTab={activeTab}
        handleChange={handleChange}
        tabName="paymentHistory"
        type="right"
      >
        Payment History
      </TabBtn>
    </div>
  )
}